module.exports = __webpack_public_path__ + "static/media/rihanna_cover.1f6e9d85.jpg";